import TYPES from '@/modules/shared/types';

// Domain
import {
  OverallGoalsStatusRepository,
} from '@/modules/flagship/investor-profile/overall-goals-status/domain/repositories/overall-goals-status-repository';
import {
  OverallGoalsStatusEntity,
} from '@/modules/flagship/investor-profile/overall-goals-status/domain/entities/overall-goals-status-entity';

import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class OverallGoalsStatusHttpRepository implements
OverallGoalsStatusRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/flagship/investor-profile/overall-goals-status/`;

  get(): Promise<OverallGoalsStatusEntity> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, error }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(error));
              }
            });
        })
        .catch(reject);
    });
  }
}
